var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$store.state.perfil==='ADMIN')?_c('HomeAdmin'):_c('HomeCandidato')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }